import { Zona } from './../../../_class/zona';
import { ZonesService } from './../../../_services/zones/zones.service';
import { GrupoZona } from './../../../_class/grupo-zona';
import { FleetsService } from './../../../_services/fleets/fleets.service';
import { GroupsService } from './../../../_services/groups/groups.service';
import { Component, OnInit, EventEmitter, ViewChild, Output, Input, OnDestroy } from '@angular/core';
import { AgmMarker } from '@agm/core/directives';
import { PageEvent, MatDialog, MatDialogConfig } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { Subject, Subscription } from 'rxjs';
import { takeUntil, takeWhile } from 'rxjs/operators';

import { InputDetalleMapa, DetalleMapaComponent } from 'app/_components/detalle-mapa/detalle-mapa.component';

import { PermisoClass } from 'app/_class/permiso';
import { LoginService } from 'app/_services/login.service';
import { RegistroHC } from 'app/_class/registro-hc';
import { Permiso } from 'app/_interfaces/permiso';
import { environment } from 'environments/environment';
import { DataService } from 'app/_services/data.service';
import { Meta } from 'app/_interfaces/meta';

import { Vehiculo } from 'app/_class/vehiculo';
import { Appearance } from '@angular-material-extensions/google-maps-autocomplete';

// IMPORTS PARA EL TIMER
import { interval } from 'rxjs/observable/interval';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/observable/timer';
import { RealtimeDataService } from 'app/_services/realtimeData/realtime-data.service';
import { FlotaActiva } from 'app/_class/indicadores/flota-activa';
import { Alerta } from 'app/_class/indicadores/alerta';
import { Actividad } from 'app/_class/indicadores/actividad';
import { FormControl } from '@angular/forms';
import { MapOptions } from 'app/_class/map-options';
import { Point } from 'app/_class/point';
import { StorageService } from 'app/_services/storage/storage.service';
import { SocketService } from '../../../_services/vehicles/socketService .service';
import { Vehiculo2 } from '../../../_class/vehiculo2';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';

const refreshingVehiclesTimeInterval = 20000; // 20000;

export interface VehiculosFilter {
  patente: string[];
  nombreFlota: string[];
  nombreGrupo: string[];
}

/**
 * @deprecated TELE-829: el Dashboard se dio de baja para los usuarios. La ruta `#/dashboard` (y sus hijas) solo
 * redirige a la Localización Instantánea nueva (`DashboardRetiradoGuard`), así que este componente ya no se
 * muestra. Se conserva el código como respaldo: no agregarle funcionalidad.
 */
@Component({
  selector: 'app-index-dashboard',
  templateUrl: './index-dashboard.component.html',
  styleUrls: [ './index-dashboard.component.css' ]
})

export class IndexDashboardComponent implements OnInit, OnDestroy {
  private alive = true;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  private strFleet = 'fleet';
  private strGroup = 'group';
  private strVehicle = 'vehicle';
  private strBase = 'dash';

  private first = true;

  // Grupos  para el cliente actualmente seleccionado
  titleDashboard = 'Tranciti | Dashboard'
  titleFlotaCompleta = 'Tranciti | Modo Flota Completa'
  groups: {};
  groupsOptions = [];
  fleetsOptions = [];
  selectedGroups = [];
  selectedFleets = [];
  vehiclesOptions = [];
  vehiclesSelected = [];
  showList = [];
  fleets: {};
  
  // TELE-578: groupsOptions/fleetsOptions (no jerárquico) se calculan una sola vez por
  // cliente, con la primera carga de vehículos, y no se recalculan en cada tick de WebSocket.
  private groupFleetOptionsInitialized = false;

  // Nuevas propiedades para grupos jerárquicos (cliente 2038)
  isJerarquicoClient = false;
  gruposJerarquicos = [];
  level1Options = [];
  level2Options = [];
  level3Options = [];
  selectedLevel1 = [];
  selectedLevel2 = [];
  selectedLevel3 = [];
  idCliente: number; // id cliente seleccionado
  idsClienteConfiguration: number[] = [];
  idsClienteFlotaConfiguration: number[] = [];
  $updateDireccion = new Subject<number>();
  pageEvent: PageEvent = null;
  pageSize = 5;
  dataTable: RegistroHC[] = [];
  dataTableVisible = [];
  /** Nativa Map Object */
  mapOptions = new MapOptions();
  markers = {};
  markersDashboard = [];
  markersFlotaCompleta = [];
  vehicles = [];
  focus = {lat: -33.428480, lng: -70.609770, id: null};
  displayedColumns: string[] =  [ 'patente', 'grupo', 'conductor' , 'flota', 'ubicacion'  , 'estado', 'accion' ];
  displayedColumnsWithBattery: string[] = [ 'patente' , 'grupo' , 'conductor', 'flota', 'ubicacion', 'bateria', 'estado', 'accion' ];
  positionSetted = null;
  inputDetalleMapa: InputDetalleMapa;
  @Output() emitterToggleSB = new EventEmitter<boolean>();
  modoFlota = false;
  // Aviso de la nueva Localización Instantánea (TELE-710). Se cierra solo en
  // memoria: al recargar o volver a iniciar sesión aparece de nuevo.
  avisoVisible = true;
  newServiceApi = false;
  dataSource: MatTableDataSource<Vehiculo>;
  alreadyLoadLatest = false;
  filterValue = '';
  vehiclesDataMap: {};
  // Indicadores
  iFlota = new FlotaActiva();
  iAlerta = new Alerta();
  iActividad = new Actividad();
  startIndex = 0;
  endIndex = 5;
  previousPageIndex = -1;
  vehiculosControl = new FormControl();
  gruposControl = new FormControl();
  flotasControl = new FormControl();
  filteredValues: VehiculosFilter = {patente: [], nombreFlota: [], nombreGrupo: []};
  s1: Subscription;
  s2: Subscription;
  s3: Subscription;
  zoneGroups: GrupoZona[] = [];
  zones: Zona[] = [];
  private loadIntervalSubscription: Subscription;
  private pageChangeSubscription: Subscription;

  private activeClientId: number = null;
  direcciones = {};

  doingChanges = false;

  @Input() set cliente(id: number) {
    this.idCliente = id;
  }
  public appearance = Appearance;
  private subscriptions: Subscription[] = [];
  private unsubscribe$ = new Subject<void>();
  constructor(
    private dataService: DataService,
    private loginService: LoginService,
    private groupsService: GroupsService,
    private fleetService: FleetsService,
    private zoneService: ZonesService,
    public dialog: MatDialog,
    private storage: StorageService,
    private realtimeDataService: RealtimeDataService,
    private socketService: SocketService,
    private readonly titleService:Title,
    private http: HttpClient) {
  }

  appVersion(){
    return environment.appVersion;
  }
  
  initComponent() {
    this.getClientConfigurateWithTxt().then(value => true);
    this.newServiceApi = false;
    this.subscribe();


    this.loginService.activarService();
    this.s2 = this.loginService.$idCliente.subscribe(id => {
      this.idCliente = id;
      this.dataService.$idCliente.next(id);
      if ( id > 0 ) {
        this.updateView();
      }
    });

    this.s3 = this.dataService.$idCliente.subscribe(id => {
      if ( id > 0 ) {
        this.updateView();
        this.loadInterval();
      }
    });
  }
  ngOnInit() {
    this.initComponent();
  }
  
  ngOnDestroy(): void {
    this.alive = false;
  
    if (this.s1) {
      this.s1.unsubscribe();
    }
  
    if (this.s2) {
      this.s2.unsubscribe();
    }
  
    if (this.s3) {
      this.s3.unsubscribe();
    }
  
    if (this.loadIntervalSubscription) {
      this.loadIntervalSubscription.unsubscribe();
    }

    if (this.pageChangeSubscription) {
      this.pageChangeSubscription.unsubscribe();
    }
    
    this.socketService.disconnect();
  
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  async getClientConfigurateWithTxt() {
    try {
      const data = await this.http.get('./configDashboard.txt', { responseType: 'text' }).toPromise() ;
      //console.log('txt', data);

      const ids = data.split(',').map(id => Number(id.trim())); // asume que los IDs están separados por comas
      this.idsClienteConfiguration = ids;
    } catch (error) {
      console.log(error);
    }
  }

  async getClientConfigurateFlotaWithTxt() {
    try {
      const data = await this.http.get('./configFlotaCompleta.txt', { responseType: 'text' }).toPromise();
      //console.log('txt', data);

      const ids = data.split(',').map(id => Number(id.trim())); // asume que los IDs están separados por comas
      this.idsClienteFlotaConfiguration = ids;
    } catch (error) {
      console.log(error);
    }
  }

  checkUserTimezone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  //limpia los datos asociados al idcliente para vaciar los selectores, la lista de vehiculos y el mapa
  cleanData(){
    this.markers = {};
    this.dataSource = new MatTableDataSource<Vehiculo>();
    // limpiar grupos, flotas, vehiculos seleccionados al cambiar de cliente
    this.selectedGroups = [];
    this.selectedFleets = [];
    this.vehiclesSelected = [];
    this.groupFleetOptionsInitialized = false;
    this.markersDashboard = [];  // Remueve todos los marcadores
    this.dataSource.paginator = this.paginator;
    this.dataSource.filteredData=[];
    if(!this.pageChangeSubscription){
      // se suscribe solo una vez al cambio de pagina
      this.pageChangeSubscription = this.dataSource.paginator.page.subscribe((pageEvent: PageEvent) => {
        if ( this.previousPageIndex !== pageEvent.previousPageIndex ) {
          this.startIndex = pageEvent.pageIndex * pageEvent.pageSize;
          this.endIndex = this.startIndex + pageEvent.pageSize;
          this.cargarDirecciones();
          this.previousPageIndex = pageEvent.previousPageIndex;
          this.pageSize = pageEvent.pageSize;
        }
      });
    }
    const userTimezone=this.checkUserTimezone()
    if (userTimezone === "America/Mexico_City") {
      this.focus = {lat: 19.432608, lng: -99.133209, id: null}; //ciudad de mexico
    } else {//"America/Santiago"
      this.focus = {lat: -33.428480, lng: -70.609770, id: null}; //stgo
    }
  }

  subscribe() {
  this.s1=this.dataService.$idCliente
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(async (id) => {
      this.activeClientId = id;
      this.socketService.disconnect();
      this.subscriptions.forEach(sub => sub.unsubscribe());
      this.subscriptions = [];
      this.cleanData();

      const savedClient = this.storage.get(this.strBase, 'client');
      console.log('--------------change client, ', savedClient, id);
      // limpia los indices para la primera pagina
      this.startIndex = 0;
      this.endIndex = this.pageSize; // si cambias el tamaño, se mantiene entre clientes

      if (!this.first && savedClient !== id) {
        this.storage.deleteAllSelections(this.strBase);
      }

      this.idCliente = id;
      this.storage.save('dash', 'client', id);
      this.realtimeDataService.getLocalizacion(this.idCliente)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(async (data: any) => {
          if(data.data.length>0){
            if (this.activeClientId !== id) {
              console.log('Datos ignorados para cliente anterior.');
              return;
            }
            this.alreadyLoadLatest = false;
            const vehicleIds = data.data.map(registro => registro.vehicleId);
            const vehicleIdsString = vehicleIds.join(',');
            try {
              await this.socketService.connect();
            } catch (error) {
              console.error('Failed to connect to WebSocket', error);
              return;
            }
            this.socketService.sendMessage(vehicleIdsString);
            this.newServiceApi = true;
            this.subscriptions.push(
              this.socketService.messages.subscribe(message => {
                //console.log("socketService active:",this.activeClientId)
                if (this.activeClientId !== id) {
                  console.log('Mensaje ignorado para cliente anterior.');
                  return;
                }

                try {
                  const messageData = JSON.parse(message);
                  const gpsDataArray = messageData.data.map((item: { gpsData: any; }) => item.gpsData);
                  if (this.alreadyLoadLatest) {
                    this.parseVehicleData(gpsDataArray, false, true);
                  }
                } catch (error) {
                  console.error('Error al parsear el mensaje del WebSocket:', error);
                }
              })
            );
          }
          this.cleanData();
          if (this.activeClientId !== id) {
            console.log('Datos ignorados para cliente anterior.');
            return;
          }
          await this.getGroups();
          await this.getFleets();
          this.loadZones();
          this.parseVehicleData(data.data, true);
          this.alreadyLoadLatest = true;
        });
    });
}

  loadZones() {
    this.zoneService.getGroups(this.idCliente).subscribe((d: any) => this.zoneGroups = d.lista);
    this.zoneService.getZones(this.idCliente).subscribe((d: any) => {
      this.zones = d.lista.map((z: Zona) => {
        return {
          ...z
        };
      });
    });
  }

  setSelect(event, type) {
    if ( event === null ) {
      event = [];
    }
    
    // Guardamos los valores anteriores para comparación
    const prevLevel1 = this.selectedLevel1 ? [...this.selectedLevel1] : [];
    const prevLevel2 = this.selectedLevel2 ? [...this.selectedLevel2] : [];
    const prevLevel3 = this.selectedLevel3 ? [...this.selectedLevel3] : [];
    

    
    switch ( type ) {
      case 'group':
        if ( !this.first ) {
          this.selectedGroups = event;
          this.storage.deleteOne(this.strBase, 'fleet');
          this.storage.deleteOne(this.strBase, 'vehicle');
        }
        // TELE-578: 'group' solo se dispara desde el flujo no jerárquico (el cliente jerárquico
        // filtra por level1/level2/level3); event ya son nombres, no requiere mapear vía this.groups.
        this.doDashboardFilter('nombreGrupo', event);
        this.getFleets();
        this.setVehiclesOptions();
        break;
      case 'level1':
        // Detectar qué grupos se han deseleccionado
        const deselectedLevel1 = prevLevel1.filter(id => !event.includes(id));
        
        if (deselectedLevel1.length > 0) {
          // Si se deseleccionaron grupos de nivel 1, debemos eliminar sus hijos de la selección de nivel 2
          // Encontrar todos los hijos directos de los grupos deseleccionados
          const childrenToRemove = this.gruposJerarquicos
            .filter(g => g.level === 2 && deselectedLevel1.includes(g.id_parent))
            .map(g => g.id);
          
          // Remover estos hijos de la selección de nivel 2
          this.selectedLevel2 = this.selectedLevel2.filter(id => !childrenToRemove.includes(id));
        }
        
        // Actualizamos la selección
        this.selectedLevel1 = event;
        
        // Y luego actualizamos las opciones de los niveles inferiores
        this.updateLevel2Options();
        break;
      case 'level2':
        // Detectar qué grupos se han deseleccionado
        const deselectedLevel2 = prevLevel2.filter(id => !event.includes(id));
        
        if (deselectedLevel2.length > 0) {
          // Si se deseleccionaron grupos de nivel 2, debemos eliminar sus hijos de la selección de nivel 3
          // Encontrar todos los hijos directos de los grupos deseleccionados
          const childrenToRemove = this.gruposJerarquicos
            .filter(g => g.level === 3 && deselectedLevel2.includes(g.id_parent))
            .map(g => g.id);
          
          // Remover estos hijos de la selección de nivel 3
          this.selectedLevel3 = this.selectedLevel3.filter(id => !childrenToRemove.includes(id));
        }
        
        // Actualizamos la selección
        this.selectedLevel2 = event;
        
        // Y luego actualizamos las opciones y selecciones de nivel 3
        this.updateLevel3Options();
        break;
      case 'level3':
        this.selectedLevel3 = event;
        this.updateJerarquicoFilter();
        break;
      case 'fleet':
        if ( !this.first ) {
          this.selectedFleets = event;
          this.storage.deleteOne(this.strBase, 'vehicle');
        }
        if (this.isJerarquicoClient) {
          this.doFilter(event, this.fleets, 'nombreFlota');
        } else {
          // TELE-578: event ya son nombres, no requiere mapear vía this.fleets
          this.doDashboardFilter('nombreFlota', event);
        }
        this.setVehiclesOptions();
        break;
      case 'vehicle':
        if ( !this.first ) {
          this.vehiclesSelected = event;
        }
        break;
      default:
        break;
    }

    this.storage.save(this.strBase, type, event);
    this.updateSelection();
  }

  updateSelection() {
    // Perf: Map/Set en vez de filter()/includes() anidados, O(n) en vez de O(n²)
    // (con >5000 vehículos y "seleccionar todo", la versión anterior tardaba varios segundos).
    const idsOptions = new Set(this.vehiclesOptions.map(o => o.id));
    this.vehiclesSelected = this.vehiclesSelected.filter(v => idsOptions.has(v));
    const vehiclesById = new Map(this.vehicles.map(v => [v.id, v]));
    const patentes = this.vehiclesSelected.map(e => vehiclesById.get(e).patente);
    this.doDashboardFilter('patente', patentes);
    this.updateView();
  }

  async setVehiclesOptions() {
    this.filterVehiclesOptions().then((res: any[]) => this.vehiclesOptions = res);
    return true;
  }

  async filterVehiclesOptions() {
    return new Promise(async (resolve, reject) => {
      this.vehiclesOptions = this.isJerarquicoClient
        ? this.vehicles.filter(veh =>
            (this.selectedGroups.length === 0 || this.selectedGroups.includes(veh.idGrupo)) &&
            (this.selectedFleets.length === 0 || this.selectedFleets.includes(veh.idClase)))
            .map(veh => ({id: veh.id, descripcion: `${veh.patente} ${veh.descripcion}`}))
        : this.vehicles.filter(veh =>
            (this.selectedGroups.length === 0 || this.selectedGroups.includes((veh.nombreGrupo || '').trim())) &&
            (this.selectedFleets.length === 0 || this.selectedFleets.includes((veh.nombreFlota || '').trim())))
            .map(veh => ({id: veh.id, descripcion: `${veh.patente} ${veh.descripcion}`}));

      if ( this.first ) {
        this.first = false;
        const restored = this.storage.get(this.strBase, this.strVehicle);
        this.vehiclesSelected = restored ? restored : [];
        const fleets = this.storage.get(this.strBase, this.strFleet);
        const groups = this.storage.get(this.strBase, this.strGroup);
        if (this.isJerarquicoClient) {
          if ( fleets ) {
            this.doFilter(fleets, this.fleets, 'nombreFlota');
          }
          if ( groups ) {
            this.doFilter(groups, this.groups, 'nombreGrupo');
          }
        } else {
          if ( fleets ) {
            this.doDashboardFilter('nombreFlota', fleets);
          }
          if ( groups ) {
            this.doDashboardFilter('nombreGrupo', groups);
          }
        }

        this.updateSelection();
      }
      resolve(this.vehiclesOptions);
    });
  }

  doFilter(event: any[], object: {}, type: string) {
    this.doDashboardFilter(type, event.map(res => object[res]));
  }

  loadInterval() {
    if (this.loadIntervalSubscription) {
      this.loadIntervalSubscription.unsubscribe();
    }
    this.loadIntervalSubscription = interval(refreshingVehiclesTimeInterval)
      .pipe(takeWhile(() => this.alive && !this.modoFlota && !this.newServiceApi))
      .subscribe(() => {
        this.getVehiclesData();
      });
  }

  async getVehiclesData(doSetOptions = false) {
    if ( this.idCliente !== undefined ) {
      this.realtimeDataService.getLocalizacion(this.idCliente)
        .subscribe((data: any) => {
          this.parseVehicleData(data, doSetOptions);
        });
    }

    return true;
  }




  private getUniqueNombresGrupo(): {id: string; descripcion: string}[] {
    const nombres = new Set<string>();
    this.vehicles.forEach(v => {
      const n = (v.nombreGrupo || '').trim();
      if (n && n !== '-') { nombres.add(n); }
    });
    return Array.from(nombres).sort().map(n => ({id: n, descripcion: n}));
  }

  private getUniqueNombresFlota(gruposSeleccionados: string[]): {id: string; descripcion: string}[] {
    const base = (gruposSeleccionados && gruposSeleccionados.length > 0)
      ? this.vehicles.filter(v => gruposSeleccionados.includes((v.nombreGrupo || '').trim()))
      : this.vehicles;
    const nombres = new Set<string>();
    base.forEach(v => {
      const n = (v.nombreFlota || '').trim();
      if (n && n !== '-') { nombres.add(n); }
    });
    return Array.from(nombres).sort().map(n => ({id: n, descripcion: n}));
  }

  async getGroups() {
    this.groups = {};
    this.groupsOptions = [];
    this.isJerarquicoClient = this.idCliente === environment.idClientSaesa;

    // Reset de opciones jerárquicas
    if (this.isJerarquicoClient) {
      this.level1Options = [];
      this.level2Options = [];
      this.level3Options = [];
    }

    if (this.isJerarquicoClient) {
      const gr = await this.groupsService.getGrupos(this.idCliente);
      this.gruposJerarquicos = gr;

      // Procesamos los grupos por niveles
      this.processJerarquicGroups();
    } else {
      // TELE-578: this.vehicles todavía está vacío en este punto (se llena recién en
      // parseVehicleData()); groupsOptions se calcula una sola vez ahí, la primera vez
      // que llegan vehículos para este cliente. Ver groupFleetOptionsInitialized.
    }
    if ( this.first ) {
      const groups = this.storage.get(this.strBase, this.strGroup);
      if ( groups ) {
        this.selectedGroups = groups;
      }
    }
  }

  async getFleets() {
    this.fleets = {};
    this.fleetsOptions = [];

    if (this.isJerarquicoClient) {
      if ( this.selectedGroups.length > 0 ) {
        for ( const gr of this.selectedGroups ) {
          const fleets = await this.fleetService.getFleets(this.idCliente, gr);
          await this.parseFleets(fleets);
        }
      } else {
        const fleets = await this.fleetService.getFleets(this.idCliente);
        await this.parseFleets(fleets);
      }
    } else {
      // TELE-578: this.vehicles todavía está vacío en este punto; fleetsOptions se calcula
      // una sola vez en parseVehicleData(). Ver groupFleetOptionsInitialized.
    }

    if ( this.first ) {
      const fleets = this.storage.get(this.strBase, this.strFleet);
      if ( fleets ) {
        this.selectedFleets = fleets;
      }
    }

    return this.fleets;
  }

  async parseFleets(data: any = []) {
    data.forEach(async ({ id, name }) => {
      if (!this.fleets[id]) {  // Verificar si fleets[id] no existe
        this.fleets[id] = name;
        this.fleetsOptions.push({ id, descripcion: name });
      }
    });
  }
  
  // Método para procesar grupos jerárquicos por niveles
  processJerarquicGroups() {
    if (!this.gruposJerarquicos || !this.gruposJerarquicos.length) return;
    

    
    // Construimos el árbol de grupos normal para mantener compatibilidad
    this.gruposJerarquicos.forEach(({id, nombre}) => {
      if (this.groups[id] === undefined) {
        this.groups[id] = nombre.trim();
        this.groupsOptions.push({id, descripcion: nombre});
      }
    });
    
    // Filtrar por niveles, solo incluir nivel 1 (no incluir nivel 0 'RAIZ' en los dropdowns)
    // Para nivel 1, mostramos el nombre tal cual
    this.level1Options = this.gruposJerarquicos
      .filter(g => g.level === 1)
      .map(g => ({id: g.id, descripcion: g.nombre}));
      

      
    // Inicialmente no hay selecciones
    this.selectedLevel1 = [];
    this.selectedLevel2 = [];
    this.selectedLevel3 = [];
    
    // Limpiar los dropdowns de nivel 2 y 3
    this.level2Options = [];
    this.level3Options = [];
  }
  
  // Actualiza las opciones de nivel 2 basadas en la selección de nivel 1
  updateLevel2Options() {
    if (!this.isJerarquicoClient) return;
    
    // Guardar selecciones anteriores para fines de depuración (si es necesario)
    const previousLevel2Selected = this.selectedLevel2 ? [...this.selectedLevel2] : [];
    
    // Limpiar opciones actuales
    this.level2Options = [];
    
    // Lista para almacenar los IDs de nivel 2 válidos
    const validLevel2OptionIds = [];
    
    if (this.selectedLevel1 && this.selectedLevel1.length) {
      // Obtener todos los grupos de nivel 2 que sean hijos DIRECTOS de los grupos seleccionados en nivel 1
      const level2Children = this.gruposJerarquicos
        .filter(g => g.level === 2 && this.selectedLevel1.includes(g.id_parent));
      
      // Crear opciones para el dropdown
      // Para nivel 2, mostramos el segundo fragmento del nombre después de dividir por '-'
      this.level2Options = level2Children.map(g => {
        const nameParts = g.nombre.split('-');
        const displayName = nameParts.length > 1 ? nameParts[1].trim() : g.nombre;
        return {id: g.id, descripcion: displayName};
      });
      
      // Guardar los IDs válidos para nivel 2
      validLevel2OptionIds.push(...level2Children.map(g => g.id));
    }
    
    // Verificar si los grupos anteriormente seleccionados en nivel 2 siguen siendo válidos
    // y forzar la deselección de los que ya no son válidos
    if (previousLevel2Selected.length > 0) {
      // Mantener solo las selecciones que siguen siendo válidas según las nuevas opciones disponibles
      const validSelections = previousLevel2Selected.filter(id => validLevel2OptionIds.includes(id));
      
      // Actualizar selecciones (forzando deselección de los no válidos)
      this.selectedLevel2 = validSelections;
    } else {
      // Si no había selección previa, inicializar como array vacío
      this.selectedLevel2 = [];
    }
    
    // Actualizar opciones de nivel 3 (esto también deseleccionará los hijos de los grupos deseleccionados)
    this.updateLevel3Options();
    
    // Actualizar filtros
    this.updateJerarquicoFilter();
  }
  
  // Actualiza las opciones de nivel 3 basadas en la selección de nivel 2
  updateLevel3Options() {
    if (!this.isJerarquicoClient) return;
    
    // Guardar selecciones anteriores para fines de depuración (si es necesario)
    const previousLevel3Selected = this.selectedLevel3 ? [...this.selectedLevel3] : [];
    
    // Limpiar opciones actuales
    this.level3Options = [];
    
    // Lista para almacenar los IDs de nivel 3 válidos
    const validLevel3OptionIds = [];
    
    if (this.selectedLevel2 && this.selectedLevel2.length) {
      // Obtener todos los grupos de nivel 3 que sean hijos DIRECTOS de los grupos seleccionados en nivel 2
      const level3Children = this.gruposJerarquicos
        .filter(g => g.level === 3 && this.selectedLevel2.includes(g.id_parent));
      
      // Crear opciones para el dropdown
      // Para nivel 3, mostramos el tercer fragmento del nombre después de dividir por '-'
      this.level3Options = level3Children.map(g => {
        const nameParts = g.nombre.split('-');
        const displayName = nameParts.length > 2 ? nameParts[2].trim() : g.nombre;
        return {id: g.id, descripcion: displayName};
      });
      
      // Guardar los IDs válidos para nivel 3
      validLevel3OptionIds.push(...level3Children.map(g => g.id));
    }
    
    // Verificar si los grupos anteriormente seleccionados en nivel 3 siguen siendo válidos
    // y forzar la deselección de los que ya no son válidos
    if (previousLevel3Selected.length > 0) {
      // Mantener solo las selecciones que siguen siendo válidas según las nuevas opciones disponibles
      const validSelections = previousLevel3Selected.filter(id => validLevel3OptionIds.includes(id));
      
      // Actualizar selecciones (forzando deselección de los no válidos)
      this.selectedLevel3 = validSelections;
    } else {
      // Si no había selección previa, inicializar como array vacío
      this.selectedLevel3 = [];
    }
    
    // Actualizar filtros
    this.updateJerarquicoFilter();
  }
  
  // Actualiza el filtro basado en las selecciones jerárquicas
  updateJerarquicoFilter() {
    if (!this.isJerarquicoClient) return;
    
    // Obtenemos todos los grupos
    const allGroups = this.gruposJerarquicos.map(g => g.id);
    
    // Obtener los grupos "RAIZ" de nivel 0 (siempre se incluirán)
    const raizGroups = this.gruposJerarquicos
      .filter(g => g.level === 0 && g.nombre.trim().toUpperCase() === 'RAIZ')
      .map(g => g.id);
    

    
    // Si no hay ninguna selección, tratar como si todos los grupos estuvieran seleccionados
    // (excepto mantener los grupos RAIZ)
    if (!this.selectedLevel1 || this.selectedLevel1.length === 0) {
      // Incluir todos los grupos como si estuvieran todos seleccionados
      // (similar al comportamiento de los otros filtros)
      this.selectedGroups = allGroups;
      this.doFilter(this.selectedGroups, this.groups, 'nombreGrupo');
      this.getFleets();
      this.setVehiclesOptions();
      return;
    }
    
    // Grupos a incluir: todos los seleccionados en nivel 1 y sus hijos, más los grupos RAIZ
    let groupsToInclude = [...this.selectedLevel1, ...raizGroups];
    
    // Añadir todos los hijos de los grupos seleccionados en nivel 1
    for (const selectedId of this.selectedLevel1) {
      const childGroups = this.getAllChildGroupIds(selectedId);
      groupsToInclude = [...groupsToInclude, ...childGroups];
    }
    
    // Si hay selecciones en nivel 2, filtramos a solo esos grupos y sus hijos
    // Si no hay selecciones en nivel 2, se consideran todos los grupos de nivel 2 como seleccionados
    if (this.selectedLevel2 && this.selectedLevel2.length > 0) {
      const level2AndChildren = [...this.selectedLevel2];
      
      // Añadir hijos de nivel 2
      for (const selectedId of this.selectedLevel2) {
        const childGroups = this.getAllChildGroupIds(selectedId);
        level2AndChildren.push(...childGroups);
      }
      
      // Solo mantener grupos que estén en level2AndChildren o en selectedLevel1
      groupsToInclude = groupsToInclude.filter(id => 
        this.selectedLevel1.includes(id) || level2AndChildren.includes(id));
    }
    // Si selectedLevel2 está vacío pero hay opciones disponibles, es como si todas estuvieran seleccionadas
    
    // Si hay selecciones en nivel 3, filtramos aún más
    // Si no hay selecciones en nivel 3, se consideran todos los grupos de nivel 3 como seleccionados
    if (this.selectedLevel3 && this.selectedLevel3.length > 0) {
      const level3AndChildren = [...this.selectedLevel3];
      
      // Añadir hijos de nivel 3
      for (const selectedId of this.selectedLevel3) {
        const childGroups = this.getAllChildGroupIds(selectedId);
        level3AndChildren.push(...childGroups);
      }
      
      // Solo mantener grupos que estén en level3AndChildren, selectedLevel1 o selectedLevel2
      groupsToInclude = groupsToInclude.filter(id => 
        this.selectedLevel1.includes(id) || 
        this.selectedLevel2.includes(id) || 
        level3AndChildren.includes(id));
    }
    // Si selectedLevel3 está vacío pero hay opciones disponibles, es como si todas estuvieran seleccionadas
    
    // Asegurarse de que los grupos RAIZ siempre están incluidos
    // Reutilizamos la misma variable raizGroups ya declarada al inicio del método
    
    // Incluir solo los grupos RAIZ si aún no están incluidos
    for (const raizId of raizGroups) {
      if (!groupsToInclude.includes(raizId)) {
        groupsToInclude.push(raizId);
      }
    }
    
    // Eliminamos duplicados
    groupsToInclude = [...new Set(groupsToInclude)];
    
    // Actualizar la selección de grupos normal para mantener compatibilidad con el resto del sistema
    this.selectedGroups = groupsToInclude;
    
    // Trigger the normal filter logic
    this.doFilter(this.selectedGroups, this.groups, 'nombreGrupo');
    this.getFleets();
    this.setVehiclesOptions();
    
    // Trigger the normal filter logic
    this.doFilter(this.selectedGroups, this.groups, 'nombreGrupo');
    this.getFleets();
    this.setVehiclesOptions();
  }
  
  // Obtiene todos los IDs de grupos hijos de un grupo dado, recursivamente
  getAllChildGroupIds(parentId: number): number[] {
    if (!this.gruposJerarquicos || !this.gruposJerarquicos.length) return [];
    
    // Encontrar hijos directos del grupo padre (incluyendo cualquier nivel, no solo hasta nivel 3)
    const directChildren = this.gruposJerarquicos
      .filter(g => g.id_parent === parentId)
      .map(g => g.id);
      
    // Si no tiene hijos, retornar arreglo vacío
    if (!directChildren.length) return [];
    
    // Para cada hijo directo, buscar sus hijos recursivamente
    let allChildren = [...directChildren];
    for (const childId of directChildren) {
      const grandChildren = this.getAllChildGroupIds(childId);
      allChildren = [...allChildren, ...grandChildren];
    }
    
    return allChildren;
  }

  doDashboardFilter(type: string, filteredValues: any) {
    this.filteredValues[type] = filteredValues;
    this.dataSource.filter = JSON.stringify(this.filteredValues);
    // Perf: sin re-sort acá; this.dataSource.data ya viene ordenado por patente desde
    // setMarkersFlotaCompleta(), y filtrar preserva el orden (no hay MatSort activo).
    this.markersDashboard = this.dataSource.filteredData;
    this.startIndex = 0;
    this.endIndex = this.pageSize;
    this.cargarDirecciones();
    this.updateFlotaActivaIndicador();

    // Log para depuración: verificar cuántos vehículos se muestran tras filtrar
    console.log(`Vehículos filtrados (${type}):`, this.dataSource.filteredData.length);
  }

  doDashboardMarkersFilter() {

  }

  updateView() {
    // Actualiza los indicadores
    this.iActividad.setLoadOff();

    const g = this.selectedGroups;
    const f = this.selectedFleets;
    const v = this.vehiclesSelected;

    /* Desactivado en TELE-578: se da de baja el KPI de Alertas del día (comentado, no borrado,
       para rollback barato) porque el servicio api-indicadores-dashboard queda deprecado.
    this.iAlerta.setLoadOff();
    const sub2 = this.loginService.getIndicadorAlerta(g, f, v).subscribe(data => {
      if (!data) {
        return;
      }
      this.iAlerta.total = data.total;
      this.iAlerta.setLoadOn();
    });
    this.subscriptions.push(sub2);
    */

    /* Desactivado porque se borró la cajita en TELE-13
    const sub3 = this.loginService.getIndicadorActividad(g, f, v).subscribe(data => {
      if (!data) {
        return;
      }
      this.iActividad.lastWeek = data.lastWeek;
      this.iActividad.beforeLastWeek = data.beforeLastWeek;
      this.iActividad.setLoadOn();
    });
    */
  }

  getBatteryImageCharging(level: number): string {
    if (level >= 0 && level <= 30) {
      return './cargando-rojo.svg';
    } else if (level > 30 && level <= 50) {
      return './cargando-amarillo.svg';
    } else if (level > 50 && level <= 100) {
      return './cargando-verde.svg';
    }
  }

  getBatteryImageNotCharging(level: number): string {
    if (level >= 0 && level <= 30) {
      return './normal-rojo.svg';
    } else if (level > 30 && level <= 50) {
      return './normal-amarillo.svg';
    } else if (level > 50 && level <= 100 ) {
      return './normal-verde.svg';
    }
    return './normal-union.svg';
  }
  getBatteryImageNeverCharged(): string {
      return './normal-union.svg';
  }

  getBatteryTextColor(level: number): string {
    if (level >= 0 && level <= 30) {
      return 'red';
    } else if (level > 30 && level <= 50) {
      return '#E8AE1B';
    } else if (level > 50 && level <= 100 ) {
      return 'green';
    }
    return '#2C2C2C';
  }

  filterIncompleteVehicles(d: any) {
    const lat = d.hasOwnProperty('lat') ? d.lat : d.latitud;
    const lng = d.hasOwnProperty('lon') ? d.lon : d.longitud;
    const imeiFilter = d.imei === null || d.imei === undefined || Number(d.imei) === 0;
    const latFilter = lat === null || Number.isNaN(lat) || lat === undefined;
    const lonFilter = lng === null || Number.isNaN(lng) || lng === undefined;

    return imeiFilter || latFilter || lonFilter;
  }

  parseVehicleData(data: any, doSetOptions = false, fromSocket = false) {
    if (data && data.length > 0) {
        let i = 0;
        for (const d of data) {
            i++;
            if (this.filterIncompleteVehicles(d)) {
                continue;
            }
            const vehicleKey = d.vehicleId !== undefined && d.vehicleId !== null ? d.vehicleId : d.vehicleid;
            const vm = this.markers[vehicleKey];
            let vc = new Vehiculo2();
            if (vm !== null && vm !== undefined) {
                vc = vm.clone();
            }
            vc.setData(d);
            if (vm === undefined || vm === null) {
                // TELE-578: nombreGrupo/nombreFlota solo se calculan la primera vez que aparece
                // el vehículo. Recalcularlos en cada tick causaba parpadeo en los filtros por
                // nombre: algunos mensajes de WebSocket no traen grupo/flota y el valor colapsaba
                // a '-', aunque el clon ya tuviera el valor correcto de antes. Se refresca solo
                // con F5 o cambio de cliente (this.markers se limpia y todo vuelve a ser "nuevo").
                const flotaById = this.getFlota(vc.idClase);
                vc.nombreFlota = flotaById !== '-' ? flotaById : (d.flota || '-');
                const grupoById = this.getGrupo(vc.idGrupo);
                vc.nombreGrupo = grupoById !== '-' ? grupoById : (d.grupo || '-');
            }
            if (vm === undefined || vm === null || !fromSocket) {
                // First time, set everything in markers
                this.markers[vc.id] = vc;
            } else {
                const incomingMillis = Number(vc.point.millis);
                const currentMillis = Number(vm.point.millis);
                const hasValidMillis = !Number.isNaN(incomingMillis) && !Number.isNaN(currentMillis);
                const isNewerByMillis = hasValidMillis ? incomingMillis > currentMillis : false;
                const isSameMillis = hasValidMillis ? incomingMillis === currentMillis : false;
                const hasStateChange = vc.clase !== vm.clase
                  || vc.estado !== vm.estado
                  || vc.color !== vm.color
                  || vc.iconDefaultUrl !== vm.iconDefaultUrl;

                // Actualizar también cuando cambia estado con mismo timestamp
                // (evita que el estado visual quede "pegado" si no cambió posición)
                if (isNewerByMillis || (isSameMillis && hasStateChange)) {
                  const prevIsOpenInfoWindow = this.markers[vc.id].isOpenInfoWindow;
                  const prevSelected = this.markers[vc.id].selected;
                  this.markers[vc.id] = vc;
                  this.markers[vc.id].isOpenInfoWindow = prevIsOpenInfoWindow;
                  this.markers[vc.id].selected = prevSelected;
                } else {
                  // No cortar el procesamiento del lote completo por un registro atrasado
                  continue;
                }
            }
        }
    } else {
        // Limpia todos los datos si el arreglo es vacío o no contiene registros válidos
        this.markers = {};
        this.vehicles = [];
        this.dataSource.data = [];
        this.markersDashboard = [];
        this.iFlota.total = 0;
        this.iFlota.activos = 0;
        this.iFlota.inactivos = 0;
        this.iFlota.setLoadOn();
        console.log("Mapa y datos limpiados debido a un arreglo vacío o datos no válidos.");
    }

    // Actualiza las opciones solo si no se limpiaron los datos
    if (data && data.length > 0) {
        this.vehicles = Object.values(this.markers);
        if (!this.isJerarquicoClient && !this.groupFleetOptionsInitialized) {
            // TELE-578: catálogo de grupos/tipos calculado una sola vez por cliente, con la
            // primera carga de vehículos. Un grupo/tipo que aparezca después no se agrega
            // al dropdown hasta recargar la página o cambiar de cliente (decisión asumida
            // para evitar que el filtro fluctúe con cada tick de WebSocket).
            this.groupFleetOptionsInitialized = true;
            this.groupsOptions = this.getUniqueNombresGrupo();
            this.fleetsOptions = this.getUniqueNombresFlota(this.selectedGroups as any as string[]);
        }
        this.setMarkersFlotaCompleta();
        this.dataSource.data = this.vehicles;
        this.dataSource.filterPredicate = this.customFilterPredicate();
        this.dataSource.paginator = this.paginator;
        if (doSetOptions) {
            this.setVehiclesOptions();
        }
        // Perf: sin re-sort acá; this.vehicles ya viene ordenado por patente desde
        // setMarkersFlotaCompleta() (línea arriba), y filtrar preserva el orden.
        this.markersDashboard = this.dataSource.filteredData;
        this.cargarDirecciones();
        this.updateFlotaActivaIndicador();
    }
}

  private updateFlotaActivaIndicador() {
    const vehiculos = this.dataSource.filteredData;
    let activos = 0;
    for (const v of vehiculos) {
      if (v.clase !== 'color-off') {
        activos++;
      }
    }
    this.iFlota.total = vehiculos.length;
    this.iFlota.activos = activos;
    this.iFlota.inactivos = vehiculos.length - activos;
    this.iFlota.setLoadOn();
  }

  // TELE-578: mantiene groupsOptions/fleetsOptions en sync con this.vehicles en cada
  // actualización de WebSocket/polling, sin reasignar referencias si el set de nombres
  // no cambió (evita resetear el buscador del select, que usa OnPush).
  setMarkersFlotaCompleta() {
    this.vehicles.sort((a, b) => a.patente.localeCompare(b.patente));
    this.markersFlotaCompleta = this.showList.length === 0 ? this.vehicles : this.vehicles.filter(v => this.showList.includes(v.id));
  }

  toggleSideBar(): void {
    if (this.modoFlota) {
      this.alive = true;
      this.initComponent();
      this.titleService.setTitle(this.titleDashboard);
    } else {
      this.ngOnDestroy();
      this.titleService.setTitle(this.titleFlotaCompleta);
    }
    this.emitterToggleSB.emit(!this.modoFlota);
    this.dataService.modoFlota = !this.modoFlota;
  }


  // Carga  los permisos para  cliente  seleccionado, mostrando u ocultado componentes
  cambiarCliente(idCliente) {
    this.startIndex = 0;
    this.endIndex = 5;
    this.loginService.$idCliente.next(idCliente);
  }

  // deprecated
  getGrupo(id: number) {
    return this.groups && this.groups[id] ? this.groups[id] : '-';

  }

  getFlota(id: number) {
    return this.fleets && this.fleets[id] ? this.fleets[id] : '-';
  }

  // Retorna  los datos [filtrados] de acuerdo a la paginacion seleccionada,
  // si no posee direccion cargada se programa la carga de la direccion
  centerMap(lat = -33.428480, lng = -70.609770, id: number = null) {
    this.focus = {lat, lng, id};
  }

  mostrarInfoWindowYCentrar(vehiculo: Vehiculo) {
    this.reportOpenCloseInfoWindowOnVehicleMarker(vehiculo);
    this.vehicles.forEach((v: Vehiculo) => v.isOpenInfoWindow = (v.imei === vehiculo.imei));
    this.centerMap(Number(vehiculo.point.lat), Number(vehiculo.point.lng), vehiculo.id);
  }

  reportOpenCloseInfoWindowOnVehicleMarker(vehiculo: Vehiculo) {
    this.markers[vehiculo.id].isOpenInfoWindow = vehiculo.isOpenInfoWindow;
    this.vehicles = Object.values(this.markers);
  }


  cerrarSesion() {
    console.log("index-dashboard?");
    this.loginService.cerrarSesion(true);
  }

  /*getPermiso(id: string): Permiso {
    let permiso: PermisoClass;
    try {
      permiso = this.loginService.permisos.filter((p) => p.id === id)[0];
    } catch ( e ) {
      permiso = new PermisoClass();
    }

    return permiso;
  }*/

  getLink(path: string): string {
    return `${environment.endPoint}${path}?${this.loginService.wpsid.getUrlEncode()}`;
  }

  getUserName() {
    return this.loginService.usrName;
  }

  /**
   * Abre la ventana PopUp DetalleMapaComponent
   *
   * @param number vehicleId
   */
  openPopUp(vehicleId: number) {
    const config = new MatDialogConfig();
    config.autoFocus = true;
    this.inputDetalleMapa = new InputDetalleMapa();

    //  busca el registroHc del cliente seleccionado ó de la flota
    this.inputDetalleMapa.data = this.markers[vehicleId];
    this.inputDetalleMapa.isDireccion = this.mapOptions.showDirections;


    config.data = this.inputDetalleMapa;
    config.panelClass = 'detalle-mapa-dialog';
    this.dialog.open(DetalleMapaComponent, config);


    this.dialog.afterAllClosed.subscribe(_ => {
      this.inputDetalleMapa = null;
    });
  }

  getTooltipMarker(regHc: RegistroHC, meta: Meta): string {
    return `${regHc[meta.patente]}   Velocidad     ${regHc[meta.sog]}`;    
  }

  /**
   * Devuelve la cadena de dirección.
   * En el hemisferio sur (latitud negativa) es:
   *  Nombre calle, número y ciudad
   * En el hemisferio norte (latitud positiva) es:
   *  Nombre calle, número, colonia, delegación, código postal, ciudad, país
   *
   * @param point
   * @param geoResponse
   */
  async _parsearDireccion(point: Point, geoResponse: any) {
    const coalesce = (text) => text === undefined ? '' : text;
    const {road, house_number, city, county, state, postcode, country} = geoResponse.detail;
    if ( house_number == null || house_number.length === 0 || house_number === '' ) {
      // no address
    }
    let result = ''
    if ( point.lat > 0 ) {
      result = `${ coalesce(road) } ${ coalesce(house_number) } ${ coalesce(city) } ${ coalesce(county) } ${ coalesce(state) } ${ coalesce(postcode) } ${ coalesce(country) }`;
    } else {
      result = `${ coalesce(road) } ${ coalesce(house_number) } ${ coalesce(city) }`;
    }

    if(result && result.trim().length === 0){
      result = geoResponse.address;
    }

    return result;
  }

  /**
   * Toggle Marker Cluster
   *
   * @param boolean enableCluster
   */
  toggleMapOptions(mapOptions: MapOptions) {
    this.mapOptions = new MapOptions(mapOptions);
  }

  /**
   *   get a new instancia of  google.maps.LatLng
   *
   * @param (number |  string) lat
   * @param (number |   string) lng
   * @returns google.maps.LatLng
   */
  getGoogleLatLng(agmMarker: AgmMarker): google.maps.LatLng {
    return new google.maps.LatLng(Number(agmMarker.latitude), Number(agmMarker.longitude));
  }


  updateSelectedVehicles(showList: any[]) {
    this.showList = showList.length === 0 ? [ 1 ] : showList;
    this.setMarkersFlotaCompleta();
  }

  customFilterPredicate() {
    // Perf: memoiza el parseo del filtro. MatTableDataSource invoca este predicado una vez
    // por fila (miles de veces con flotas grandes) pasando el mismo string de filtro cada vez.
    let lastFilter: string;
    let lastSearch: VehiculosFilter;
    return (data: any, filter: string): boolean => {
      if (filter !== lastFilter) {
        lastFilter = filter;
        lastSearch = JSON.parse(filter) as VehiculosFilter;
      }
      const searchString = lastSearch;
      let isPatenteAvailable = false;

      if ( searchString.patente.length ) {
        for ( const d of searchString.patente ) {
          if ( data.patente.toString().trim() === d.toString().trim() ) {
            isPatenteAvailable = true;
          }
        }
      } else {
        isPatenteAvailable = true;
      }

      let isGrupoAvailable = false;

      if ( searchString.nombreGrupo.length ) {
        for ( const d of searchString.nombreGrupo ) {
          if ( data.nombreGrupo.toString().trim() === d ) {
            isGrupoAvailable = true;
          }
        }
      } else {
        isGrupoAvailable = true;
      }

      let isFlotaAvailable = false;

      if ( searchString.nombreFlota.length ) {
        for ( const d of searchString.nombreFlota ) {
          if ( data.nombreFlota.toString().trim() === d ) {
            isFlotaAvailable = true;
          }
        }
      } else {
        isFlotaAvailable = true;
      }

      return isPatenteAvailable && isGrupoAvailable && isFlotaAvailable;
    };
  }

  putPosition({point, address}) {
    this.positionSetted = {
      ...point,
      address,
      icon: {
        url: `./pin.svg`,
        scaledSize: {
          width: 40,
          height: 40
        }
      }
    };
  }

  /**
   * Actualiza la dirección de los vehículos visibles en la página actual.
   * Hace un único llamado al endpoint con ?direccion=true en lugar de N reverse geocoding.
   */
  cargarDirecciones() {
    const vehiculosAResolver: any[] = [];

    for (let i = this.startIndex; i < this.endIndex; i++) {
      const el = this.dataSource.filteredData[i];
      if (!el) { continue; }

      // Reutilizar dirección guardada si la posición no cambió
      if (el.lastPoint !== undefined && el.lastPoint.lat === el.point.lat && el.lastPoint.direccion !== '---') {
        el.point.direccion = el.lastPoint.direccion;
        continue;
      }

      if (!el.point.lat || !el.point.lng || el.point.lat === 0 || el.point.lng === 0) { continue; }

      vehiculosAResolver.push(el);
    }

    if (vehiculosAResolver.length === 0) { return; }

    const vehicleIds: number[] = vehiculosAResolver
      .map(v => v.id)
      .filter((id): id is number => id != null);

    if (vehicleIds.length === 0) { return; }

    this.realtimeDataService.getLocalizacionConDirecciones(this.idCliente, vehicleIds).subscribe(respuesta => {
      const dirMap: { [vehicleId: number]: string } = {};
      respuesta.forEach(v => {
        if (v.vehicleId && v.direccion) { dirMap[v.vehicleId] = v.direccion; }
      });
      vehiculosAResolver.forEach(el => {
        el.point.direccion = el.id != null ? (dirMap[el.id] !== undefined ? dirMap[el.id] : '---') : '---';
      });
    });
  }

}
